"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../paymentStatusEventCreators/factory");
var globalEventCreators_1 = require("../../globalEventCreators");
var utils_1 = require("../../utils");
var paymentStatusReceiptHandler = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.PaymentStatusReceiptLoad || context.isHandled) {
        return;
    }
    // main:
    var mainEventData = (0, factory_1.getCreator)(event.eventName)(event);
    (0, utils_1.pushEvent)(mainEventData);
    // login:
    if (event.loggedInUser) {
        var loginEvent = (0, globalEventCreators_1.createLoginEvent)(event);
        (0, utils_1.pushEvent)(loginEvent);
    }
    //pageload:
    var pageload = (0, globalEventCreators_1.createPageloadEvent)(event);
    (0, utils_1.pushEvent)(pageload);
    context.isHandled = true;
};
exports.default = paymentStatusReceiptHandler;
